import PhotosCard from "./PhotosCard";
export default PhotosCard;
